import { getObj2 } from './fetch'

export type ApiCallType = {
  apiType: string // invoice, template, generalのはず
  date: string
  apiCallCount: number
}

export type MaxUsersType = {
  count: number
}

export type UsersType = {
  count: number
}

export async function fetchApiCalls(
  unit: 'day' | 'month',
  params: Record<string, string>,
) {
  return getObj2<ApiCallType[]>(`metrics/api-calls/${unit}`, { params })
}

export async function fetchMaxUsers(month: number) {
  return getObj2<MaxUsersType>(`metrics/users/month/${month}`)
}

export async function fetchUsers() {
  return getObj2<UsersType>('metrics/users')
}
